// extracted by mini-css-extract-plugin
export default {"primary":"#003a74","secondary":"#0b72d9","error":"#d15744","pageTitleWrapper":"pageTitle_pageTitleWrapper__NzZxT","title":"pageTitle_title__RAdPm","Back":"pageTitle_Back__Lw0W3"};